import { render, staticRenderFns } from "./DocumentViewerToolbar.vue?vue&type=template&id=745400cc&"
import script from "./DocumentViewerToolbar.vue?vue&type=script&lang=ts&"
export * from "./DocumentViewerToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports